import { Component, OnInit, Inject } from '@angular/core';
import { CursoService } from "../../servicios/curso.service";
import { ActivatedRoute } from "@angular/router";
import { Observable } from 'rxjs';
import { cursoI } from 'src/app/shared/models/curso.interface';
import { CursoUsuarioService } from 'src/app/servicios/curso-usuario.service';

import { AuthService } from 'src/app/servicios/auth.service';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'app-details-curso',
  templateUrl: './details-curso.component.html',
  styleUrls: ['./details-curso.component.scss']
})
export class DetailsCursoComponent implements OnInit {

  public curso$:Observable<cursoI>;

  public comentarioo;

  public likes = 0;
  
 public link:any;


  constructor(@Inject(DOCUMENT) document: any,private route:ActivatedRoute, private cursoSvc:CursoService, private cuSvc:CursoUsuarioService, private authSvc:AuthService) { }

  ngOnInit(): void {

    this.link = document.location.href;
    //traigo un curso a partir del id del curso el cual lo agarro con el route
    let id = this.route.snapshot.params.id;
    
    this.curso$ = this.cursoSvc.getOneCurso(id);


    this.authSvc.visitantes(id);

  
      
   
  }//fin oninit


  sumarLike()
  {
    this.likes++;
   
  }

  enviarComentario(nota, coment)
  {
    //console.log(nota, coment);
    nota.comentarios.push(coment);
    this.cursoSvc.editCursoById(nota);
    this.comentarioo = "";
  }

}
